export const apiKeySessionStoragePropName = "yello-scout-client-api-key";

export function getApiKeyFromSessionStorage() {
  return window.sessionStorage.getItem(apiKeySessionStoragePropName);
}

export function setApiKeyToSessionStorage(apiKey) {
  window.sessionStorage.setItem(apiKeySessionStoragePropName, apiKey);
}
